import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44424da9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLCostTable" }
const _hoisted_2 = { class: "w-full table-auto border-collapse" }
const _hoisted_3 = { class: "bg-gray-200" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = { key: 8 }
const _hoisted_13 = { key: 9 }
const _hoisted_14 = { key: 10 }
const _hoisted_15 = { key: 11 }
const _hoisted_16 = { key: 12 }
const _hoisted_17 = { key: 13 }
const _hoisted_18 = { key: 14 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { key: 6 }
const _hoisted_26 = { key: 7 }
const _hoisted_27 = { key: 8 }
const _hoisted_28 = { key: 9 }
const _hoisted_29 = { key: 10 }
const _hoisted_30 = { key: 11 }
const _hoisted_31 = { key: 12 }
const _hoisted_32 = { key: 13 }
const _hoisted_33 = { key: 14 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Перевозчик"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_5, "Единица измерения"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_6, " Себестоимость за перевозку " + _toDisplayString(_ctx.paymentRateTypeFirst) + " (без НДС) ", 1))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Кол-во часов"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_8, "Кол-во часов простоя"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Себестоимость за простой"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Итого (без НДС)"))
          : _createCommentVNode("", true),
        (_ctx.isFirst)
          ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Итого (с НДС)"))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Кол-во часов АВТО"))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_13, " Выставление за перевозку " + _toDisplayString(_ctx.paymentRateTypeSecond) + " (без НДС) ", 1))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_14, " Выставление за перевозку " + _toDisplayString(_ctx.paymentRateTypeSecond) + " (с НДС) ", 1))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_15, "Выставление за простой"))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_16, "Итого (включая доп услуги)"))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_17, "Сумма выставления по перевозке(без НДС)"))
          : _createCommentVNode("", true),
        (_ctx.isSecond)
          ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Сумма выставления по перевозке(с НДС)"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(_ctx.ftlOrder.cost_price_info ? _ctx.ftlOrder.cost_price_info.carrier_name : '') + " (" + _toDisplayString(_ctx.ftlOrder.cost_price_with_nds ? 'НДС включен' : 'НДС не включен') + ") ", 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_20, _toDisplayString(_ctx.ftlOrder.cost_price_info
                                ? _ctx.ftlOrder.cost_price_info.payment_rate_type
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.ftlOrder.cost_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.cost_price_info.delivery_cost_price)
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(_ctx.ftlOrder.cost_price_info ? _ctx.ftlOrder.cost_price_info.auto_duration : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.ftlOrder.cost_price_info ? _ctx.ftlOrder.cost_price_info.downtime : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(_ctx.ftlOrder.downtime ? _ctx.ftlOrder.downtime.costPrice : '-'), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(_ctx.ftlOrder.cost_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.cost_price_info.final_sum_without_vat)
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isFirst)
            ? (_openBlock(), _createElementBlock("td", _hoisted_26, _toDisplayString(_ctx.ftlOrder.cost_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.cost_price_info.final_sum_with_vat)
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString(_ctx.ftlOrder.paid_price_info ? _ctx.ftlOrder.paid_price_info.auto_duration : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_28, _toDisplayString(_ctx.ftlOrder.paid_price_info
                                ? _ctx.formatAmount(
                                      _ctx.ftlOrder.paid_price_info.delivery_paid_price_without_vat
                                  )
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(_ctx.ftlOrder.paid_price_info
                                ? _ctx.formatAmount(
                                      _ctx.ftlOrder.paid_price_info.delivery_paid_price_with_vat
                                  )
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_30, _toDisplayString(_ctx.ftlOrder.downtime ? _ctx.ftlOrder.downtime.paidPrice : '-'), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(_ctx.ftlOrder.paid_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.paid_price_info.paid_price_total)
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString(_ctx.ftlOrder.paid_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.paid_price_info.paid_price_without_vat)
                                : ''), 1))
            : _createCommentVNode("", true),
          (_ctx.isSecond)
            ? (_openBlock(), _createElementBlock("td", _hoisted_33, _toDisplayString(_ctx.ftlOrder.paid_price_info
                                ? _ctx.formatAmount(_ctx.ftlOrder.paid_price_info.paid_price_with_vat)
                                : ''), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}